import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, shallowEqual, useSelector } from 'react-redux';

import useGeneratePassword from 'hooks/useGeneratePassword';

import { actions as usersActions } from 'features/users/redux';
import { actions as authActions } from 'features/Auth';

const initialState = {
  newPassword: '',
  repeatNewPassword: '',
};

const useModalChangePassword = () => {
  const dispatch = useDispatch();
  const { isAuth, email, id, changedPassword } = useSelector(state => state.auth, shallowEqual);

  const [state, setState] = useState(initialState);
  const [showModal, setShowModal] = useState(false);

  const generatePassword = useGeneratePassword(true);

  useEffect(() => {
    let timer;

    if (isAuth) {
      timer = setTimeout(() => setShowModal(true), 100);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [isAuth]);

  const handleChangeState = useCallback((key, value) => {
    setState(prev => ({ ...prev, [key]: value }));
  }, []);

  const onGeneratePassword = useCallback(() => {
    const password = generatePassword();
    handleChangeState('newPassword', password);
    handleChangeState('repeatNewPassword', password);

    // navigator.clipboard.writeText(password).then(() => {
    //   dispatch(addNotify(locale.copiedSuccessfully, 'success'));
    // });
  }, [handleChangeState, generatePassword, /* dispatch, locale */]);

  const handleFormSubmit = e => {
    e.preventDefault();
    const { newPassword, repeatNewPassword } = state;

    const callback = () => {
      setState(initialState);
      const checkAuth = () => dispatch(authActions.checkAuth());
      dispatch(authActions.login(email, newPassword, checkAuth));
      // () => history.push('/users/all')
    };

    dispatch(usersActions.changePassword({ data: { password: newPassword }, id, callback }));

    // dispatch(
    //   profileActions.requiredChangePassword({
    //     newPassword,
    //     repeatNewPassword,
    //     callback,
    //   }),
    // );
  };

  const handleModalClose = () => setShowModal(false);

  const forShow = !changedPassword && isAuth && showModal;

  const disabled = useMemo(
    () =>
      !state.newPassword ||
      !state.repeatNewPassword ||
      state.newPassword !== state.repeatNewPassword,
    [state],
  );

  return {
    state,
    handleFormSubmit,
    handleModalClose,
    handleChangeState,
    onGeneratePassword,
    forShow,
    disabled,
  };
};

export default useModalChangePassword;
